import React from 'react'
import { useHistory } from 'react-router-dom'
import { Container } from '../../../components'
import { ChevronLeft } from 'react-feather'
import auth from '../../../utils/auth'

const PageHeader = () => {
  const history = useHistory()
  const { isOfficial, isVerified } = auth()

  return (
    <Container className={`page-header ${isOfficial ? 'official' : isVerified ? 'verified' : ''} py-5 lg:py-8`} color="#f5f5f5">
      <div className="flex justify-between items-center">
        <div
          className="flex items-center cursor-pointer"
          onClick={() => history.push('/organization')}
        >
          <ChevronLeft style={{width: '16px'}} className="mr-4"/>
          <div className="text-xs lg:text-sm leading-none">Back to Organization List</div>
        </div>
      </div>
    </Container>
  )
}

export { PageHeader }